<template>
  <div class="temporary-expenditure">
    <div class="return-aside">
      <!-- 仓库信息 -->
      <div class="warehouse-container">
        <transition
          enter-active-class="animated fadeIn"
          leave-active-class="animated fadeOut"
        >
          <span v-if="warehouseCurrentPag > 1" class="pro-page" @click="proPage"></span>
        </transition>
        
        <div class="warehouse-group-container">
          <div
            class="warehouse-group"
            :class="{'warehouse-group-ative':(jIdx+1) === warehouseCurrentPag}"
            v-for="(j, jIdx) in warehouseList" 
            :key="jIdx"
          >
            <div
              class="warehouse-group-row" 
              :class="{'is-active': `${jIdx}-${idx}` === activeIndex}"
              v-for="(v, idx) in j" 
              :key="idx"
              @click="selectWarehouse(v, idx, jIdx)"
            >
              <div class="warehouse-name">
                <span :title="v.name">{{ v.name }}</span>
              </div>
            </div>
          </div>
        </div>
        
        <transition
          enter-active-class="animated fadeIn"
          leave-active-class="animated fadeOut"
        >
          <span v-if="warehouseList.length > 1 && warehouseCurrentPag < warehouseList.length" class="next-page" @click="nextPage"></span>
        </transition>
      </div>

      <!-- 公司信息 -->
      <div class="company-container">
        <div
          class="company-row"
          :class="{'company-row-active': index === companyIndex}"
          v-for="(item, index) in companyList"
          :key="index"
          @click="selectCompay(item, index)"
        >
          <div class="company-name">
            <img class="company-img" src="../../../../assets/images/supplier/company-img.png">
            <p class="name">{{ item.name }}</p>
          </div>
          <div class="company-info">
            <div class="people-nums">
              <span class="title">总人数</span>
              <span class="content">{{item.peopleNums}}</span>
            </div>
            <div class="total-time">
              <span class="title">总工时</span>
              <span class="content">{{item.totalManHours}}</span>
            </div>
            <div class="total-amout">
              <span class="title">总金额</span>
              <span class="content">{{item.totalAmount}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 支出列表 -->
    <div class="temporary-expenditure-right">
      <div class="temporary-expenditure-right-container">
        <div class="search">
          <el-form
            :model="form"
            ref="form"
          >
            <div class="form-row">
              <el-form-item prop="date" label="日期：">
                <el-date-picker
                  v-model="form.date"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  @change="changeDate"
                ></el-date-picker>
              </el-form-item>
              <el-form-item prop="name" label="员工名称：">
                <el-input
                  v-model="form.name"
                  placeholder="请输入员工名称"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button icon="el-icon-search" class="btn-blue" @click="searchData">搜索</el-button>
                <el-button icon="el-icon-refresh" class="btn-gray" @click="reset('form')">重置</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>

        <div class="title-container">
          <p class="table-title">支出信息</p>
          <div class="btn">
            <div class="upload-return" @click="openExportExcelForm">
              <span class="upload-return-img"></span>
              <span>导出</span>
            </div>
          </div>
        </div>

        <div class="table" :class="{'avtive-table':isVerify}">
          <el-table 
            :data="tableData" 
            style="width: 100%" 
            :header-cell-class-name="headerCellClassName"
          >
            <el-table-column
              v-for="(item, index) in tableTitle"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              show-overflow-tooltip
              :class-name="item.alignment === 'right'?`cell-right-align-width`:''"
            >
            </el-table-column>
            <el-table-column label="操作" min-width="90">
              <template slot-scope="scope">
                <el-button :class="isVerify?'btn-text-gray':'btn-text'" type="text" @click="mod(scope.row)"
                :disabled="isVerify"
                  >编辑</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <pagination-tpl
              :total="total"
              :currentPage="currentPage"
              :pageSize="pageSize"
              @queryChange="queryChange"
            ></pagination-tpl>
          </div>
        </div>
      </div>
      <div class="footer" v-if="!isVerify || isWithdrawalVerification">
        <el-button v-if="!isVerify" class="btn-blue" @click="verify">
          <img class="mod-white" src="../../../../assets/images/product/mod-white.png">
          核实
        </el-button>
        <el-button v-if="isVerify && isWithdrawalVerification" class="btn-white" @click="withdrawalVerification">
          撤回核实
        </el-button>
      </div>
    </div>

    
    <!-- 编辑公司 -->
    <el-drawer
      title="编辑"
      :visible.sync="drawer"
      :wrapperClosable="false"
      :before-close="handleCloseDrawer">
      <el-form
        ref="modForm"
        :model="modForm"
      >
        <el-form-item label="员工名称" prop="name">
          <el-input v-model="modForm.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="工种" prop="workType">
          <el-select
            v-model="modForm.workType"
            placeholder="请选择"
            class="white"
          >
            <el-option
              v-for="item in workTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时薪（元）" prop="hourlyWage">
          <el-input v-model="modForm.hourlyWage" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="工时" prop="workTime">
          <el-input v-model="modForm.workTime" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="餐费" prop="meals">
          <el-input v-model="modForm.meals" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="奖惩" prop="rewardsAndPunishments">
          <el-input v-model="modForm.rewardsAndPunishments" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" v-model="modForm.remarks" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseDrawer">取消</el-button>
        <el-button class="btn-blue" @click="submit">确定</el-button>
      </div>
    </el-drawer>

    <!-- 批量导出 -->
    <el-drawer
      class="batch-export"
      title="导入"
      :visible.sync="batchExportDrawer"
      :wrapperClosable="false"
      :before-close="handleCloseBatchExportDrawer">
      <div class="el-drawer__body">
        <el-form ref="batchExportForm" :model="batchExportForm" :rules="rules">
          <p class="sub-title base-title">基本信息</p>
          <el-form-item label="仓库名称" prop="warehouseName">
            <el-input v-model="batchExportForm.warehouseName" placeholder="请输入" disabled></el-input>
          </el-form-item>
          <el-form-item label="劳务公司" prop="companyName">
            <el-input v-model="batchExportForm.companyName" placeholder="请输入" disabled></el-input>
          </el-form-item>
          <el-form-item label="日期" prop="date">
            <el-date-picker
              v-model="batchExportForm.date"
              type="daterange"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              range-separator="-"
              start-placeholder="默认当天"
              end-placeholder="默认当天"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseBatchExportDrawer">取消</el-button>
        <el-button class="btn-blue" @click="exportExcel('batchExportForm')">确定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import warehouseMixins from '@/common/mixins/warehouse.js'
import workTypeMixins from "@/common/mixins/work-type";
import Temporary from "models/temporary";
const temporary = new Temporary();
import PaginationTpl from "components/base/PaginationTpl";
import { numsToRMBSymbolAndMillimeter, formatTimeToDate, downLoadFileByBlob } from "common/js/util";
export default {
  mixins: [warehouseMixins, workTypeMixins],
  components: {
    PaginationTpl,
  },

  data() {
    return {
      // 当前仓库下标
      activeIndex: '0-0',
      // 当前仓库组下标
      warehouseCurrentPag: 1,
      // 当前项目下标
      companyIndex: 0,
      warehouseId: null,
      companyList: [],
      companyId: null,

      form: {
        date: this.timeDefault(),
        name: ''
      },
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitle: [
        {label: '员工名称', prop: 'name', width: '110', alignment:'left'},
        {label: '时薪', prop: 'hourlyWage', width: '', alignment:'right'},
        {label: '工种', prop: 'workTypeVal', width: '', alignment:'left'},
        {label: '上班时间', prop: 'workShift', width: '150', alignment:'left'},
        {label: '下班时间', prop: 'closingTime', width: '150', alignment:'left'},
        {label: '工时', prop: 'workTime', width: '', alignment:'left'},
        {label: '餐费', prop: 'meals', width: '', alignment:'right'},
        {label: '奖惩', prop: 'rewardsAndPunishments', width: '', alignment:'right'},
        {label: '当日工费', prop: 'laborCostOfTheDay', width: '', alignment:'right'},
        {label: '实际支出', prop: 'actualExpenditure', width: '', alignment:'right'},
        {label: '备注', prop: 'remarks', width: '130', alignment:'left'},
      ],
      drawer: false,
      modForm: {
        id: null,
        name: '',
        workType: null,
        hourlyWage: '',
        workTime: null,
        meals: 0,
        rewardsAndPunishments: 0,
        remarks: ''
      },
      // 是否展示核实按钮
      isVerify: true,
      // 是否展示撤回核实按钮
      isWithdrawalVerification: true,
      // 批量导出
      batchExportDrawer: false,
      batchExportForm: {
        warehouseName: '',
        // 导出日期
        date: this.timeDefaultRang(),
        companyName: ''
      },
      rules: {
        date: [
          { required: true, message: '请选择日期', trigger: 'change' },
        ],
      },
      selectDate: "",
      //日期选择范围在31天内
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = "";
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== "") {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        },
      },
    }
  },

  async created() {
    await this.initAsyncWarehouse()
    this.warehouseList = this.spitArr(this.warehouseList)
    // 默认展示第一个仓库
    this.selectWarehouse(this.warehouseList[0][0],0,0)
  },

  methods: {
    /** 
     * @desc 默认日期范围为当天至当天
    */
    timeDefaultRang() {
      let date = new Date();
      const firstDate = formatTimeToDate(date.getTime())
      let arr = [firstDate, firstDate]
      return arr;
    },
    /** 
     * @desc 是否核实
    */
    initIsVerifyExpenditure() {
      let reportDate = this.form.date
      let laborId = this.companyId
      let data = {
        warehouseId: this.warehouseId,
        reportDate,
        laborId
      }
      temporary.getIsVerifyExpenditure(data).then(res => {
        if (res.success) {
          this.isVerify = res.result
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /** 
     * @desc 根据仓库获取劳务公司列表
    */
    initTempLaborListByWarehouse() {
      let warehouseId = this.warehouseId
      let startDate = this.form.date
      let endDate = this.form.date
      let data = {
        warehouseId,
        startDate,
        endDate
      }
      temporary.getTempLaborListByWarehouse(data).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.name = i.laborName
            obj.peopleNums = i.num
            obj.totalManHours = i.hours
            obj.totalAmount = numsToRMBSymbolAndMillimeter(i.amount)
            arr.push(obj)
          })
          this.companyList = arr
          if (this.companyList.length) {
            // 默认展示第一个公司
            this.selectCompay(this.companyList[0], 0)
          } else {
            this.tableData = []
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /** 
     * @desc 支出信息列表
    */
    initExpenditureList() {
      let currentPage = this.currentPage
      let warehouseId = this.warehouseId
      let laborId = this.companyId
      let name = this.form.name
      let startDate = this.form.date
      let endDate = this.form.date
      let data = {
        laborId,
        warehouseId,
        name,
        startDate,
        endDate,
        currentPage
      }
      temporary.getExpenditureList(data).then(res => {
        if (res.success) {
          let arr = []
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.name = i.name
            obj.hourlyWage = numsToRMBSymbolAndMillimeter(i.hourSalary)
            obj.hourlyWageCopy = i.hourSalary
            obj.workTypeVal = this.workTypeObj[i.type]
            obj.workType = i.type
            obj.workShift = i.startTime
            obj.closingTime = i.endTime
            obj.workTime = i.hours
            obj.remarks = i.remarks
            obj.mealsCopy = i.meal
            obj.rewardsAndPunishmentsCopy = i.rewardPunishment
            obj.laborCostOfTheDayCopy = i.laborSalary
            obj.actualExpenditureCopy = i.laborCost
            obj.meals = numsToRMBSymbolAndMillimeter(i.meal)
            obj.rewardsAndPunishments = numsToRMBSymbolAndMillimeter(i.rewardPunishment)
            obj.laborCostOfTheDay = numsToRMBSymbolAndMillimeter(i.laborSalary)
            obj.actualExpenditure = numsToRMBSymbolAndMillimeter(i.laborCost)
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    spitArr(arr) {
      let newArr = [];
      /* 将一位数组分割成每2个一组 */
      for (let j = 0; j < arr.length; j += 2) {
        newArr.push(arr.slice(j, j + 2));
      }
      return newArr;
    },

    /**
     * @desc 选择仓库
     * @params row: 仓库对象; index：仓库下标; parentIndex: 当前仓库组下标;
     */
    selectWarehouse(row, index, parentIndex) {
      this.warehouseId = row.id
      this.batchExportForm.warehouseName = row.name
      this.activeIndex = `${parentIndex}-${index}`
      this.warehouseCurrentPag = parentIndex+1
      this.initTempLaborListByWarehouse()
    },
    
    nextPage() {
      if (this.warehouseCurrentPag < this.warehouseList.length) this.warehouseCurrentPag++
    },

    proPage() {
      if (this.warehouseCurrentPag > 1) this.warehouseCurrentPag--
    },

    /**
     * @desc 选择公司
     */
    selectCompay(row, index) {
      this.companyIndex = index
      this.companyId = row.id
      this.batchExportForm.companyName = row.name
      this.initIsVerifyExpenditure()
      this.initExpenditureList()
    },

    
    /** 
     * @desc 默认到当天的前一天
    */
    timeDefault() {
      let date = new Date();
      const yesterday = formatTimeToDate(date.getTime() - 86400000)
      return yesterday;
    },

    changeDate() {
      this.initTempLaborListByWarehouse()
    },

    searchData() {
      this.currentPage = 1
      this.initIsVerifyExpenditure()
      this.initExpenditureList()
    },

    reset(formName) {
      this.$refs[formName].resetFields();
    },

    mod(row) {
      this.modForm.id = row.id;
      this.modForm.name = row.name;
      this.modForm.workType = row.workType;
      this.modForm.hourlyWage = row.hourlyWageCopy;
      this.modForm.workTime = row.workTime;
      this.modForm.meals = row.mealsCopy;
      this.modForm.rewardsAndPunishments = row.rewardsAndPunishmentsCopy;
      this.modForm.remarks = row.remarks;
      this.drawer = true
    },

    /** 
     * @desc 核实
    */
    verify() {
      this.$confirm("核实后，该数据将不可编辑，请确认", "核实", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-gray'
      }).then(() => {
        let reportDate = this.form.date
        let laborId = this.companyId
        let data = {
          warehouseId: this.warehouseId,
          reportDate,
          laborId
        }
        temporary.postVerifyExpenditure(data).then(res => {
          if (res.success) {
            this.initIsVerifyExpenditure()
            this.initExpenditureList()
          } else {
            this.$message.error(res.message)
          }
        })
      });
    },

    /** 
     * @description 撤回核实
    */
    withdrawalVerification() {
      let reportDate = this.form.date
      let laborId = this.companyId
      let data = {
        warehouseId: this.warehouseId,
        reportDate,
        laborId
      }
      temporary.postWithdrawalVerification(data).then(res => {
        if (res.success) {
          this.initIsVerifyExpenditure()
          this.initExpenditureList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    
    /**
     * @desc 表头添加类名处理数字右对齐
     */
    headerCellClassName({ columnIndex }) {
      if ((columnIndex > 5 && columnIndex < 10) || columnIndex == 1) {
        return 'right-align'
      }
    },

    /** 
     * @desc 翻页
    */
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initExpenditureList();
    },

    handleCloseDrawer() {
      this.$refs['modForm'].resetFields();
      this.drawer = false
    },

    submit() {
      let id = this.modForm.id;
      let name = this.modForm.name;
      let type = this.modForm.workType;
      let hourSalary = this.modForm.hourlyWage;
      let hours = this.modForm.workTime;
      let meal = this.modForm.meals;
      let rewardPunishment = this.modForm.rewardsAndPunishments;
      let remarks = this.modForm.remarks;
      let data = {
        id,
        name,
        type,
        hourSalary,
        hours,
        meal,
        rewardPunishment,
        remarks
      };
      temporary.postModExpenditure(data).then(res => {
        if (res.success) {
          this.handleCloseDrawer();
          this.initExpenditureList();
        } else {
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      });
    },

    /** 
     * @desc 开启批量导出
    */
    openExportExcelForm() {
      this.batchExportDrawer = true
    },

    /** 
     * @desc 关闭批量导出
    */
    handleCloseBatchExportDrawer() {
      this.$refs['batchExportForm'].resetFields();
      this.batchExportDrawer = false
    },
    
    /** 
     * @desc 导出
    */
    exportExcel(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let warehouseId = this.warehouseId
          let laborId = this.companyId
          let startDate = this.batchExportForm.date.length?this.batchExportForm.date[0]:''
          let endDate = this.batchExportForm.date.length?this.batchExportForm.date[1]:''
          let data = {
            warehouseId,
            laborId,
            startDate,
            endDate,
          }
          temporary.getExportExcel(data).then((res) => {
            downLoadFileByBlob(res)
            this.handleCloseBatchExportDrawer()
          });
         } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/production/temporary-expenditure.scss';
</style>
